import { RGBColor } from 'react-color';

export const hex8ToRgba = (hex?: string) => {
  if (!hex) return { r: 0, g: 0, b: 0, a: 0 };

  const normalized = hex.replace('#', '');
  const isHex = /^[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/.test(normalized);

  // return 'red' 'white' value
  if (!isHex) {
    return hex;
  }

  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  const a = parseInt(normalized.slice(6, 8), 16) / 255;

  return {
    r,
    g,
    b,
    a: Number(a.toFixed(3)),
  };
};

export const rgbaToHex8 = (rgb: RGBColor): string => {
  const toHex = (value: number) =>
    value.toString(16).padStart(2, '0').toUpperCase();

  const hex = '#' + toHex(rgb.r) + toHex(rgb.g) + toHex(rgb.b);

  if (rgb.a === undefined) {
    return hex;
  }

  const alpha = Math.round(rgb.a * 255);

  return hex + toHex(alpha);
};
